import { observable, action } from 'mobx';
import ApiCaller from '../utils/api-caller';
import adminI18n from '../admin/i18n/adminI18n';

class outOfStockRecipientStore {
    @observable outOfStockRecipients = [];
    @observable outOfStockRecipientId = 0;
    @observable email = '';

    @observable showUpdateOutOfStockRecipientModal = false;

    @observable manageOutOfStockRecipientTitle = '';

    @observable updateLoading = false;
    @observable listLoading = false;
    @observable categoryLoading = false;

    @action init() {
        this.setShowUpdateOutOfStockRecipientModal(false);
        this.listLoading = true;

        return ApiCaller.OutOfStockRecipient.GetAll().then((response) => {
            this.outOfStockRecipients = response;
            this.listLoading = false;
        })
    }

    @action initCreate() {
        this.updateLoading = false;
        this.showUpdateOutOfStockRecipientModal = true;
        this.manageOutOfStockRecipientTitle = adminI18n.t('Add Out of Stock Recipient');
        this.outOfStockRecipientId = 0;
        this.email = '';
    }

    @action initUpdate(value) {
        this.showUpdateOutOfStockRecipientModal = true;
        this.updateLoading = true;
        this.outOfStockRecipientId = value;
        this.manageOutOfStockRecipientTitle = adminI18n.t('Update Out of Stock Recipient');

        return ApiCaller.OutOfStockRecipient.GetById(this.outOfStockRecipientId).then((response) => {
            this.outOfStockRecipientId = response.outOfStockRecipientId;
            this.email = response.email;
            this.updateLoading = false;
        });
    }

    @action setOutOfStockRecipientId(value) { this.outOfStockRecipientId = value }
    @action setEmail(value) { this.email = value }
    @action setShowUpdateOutOfStockRecipientModal(value) { this.showUpdateOutOfStockRecipientModal = value }

    @action updateOutOfStockRecipient() {
        this.updateLoading = true
        return ApiCaller.OutOfStockRecipient.Update(
            this.outOfStockRecipientId,
            this.email).then(() => {
                this.init();
            })
    }

    @action createOutOfStockRecipient() {
        this.updateLoading = true
        return ApiCaller.OutOfStockRecipient.Create(
            this.email).then(() => {
                this.init();
            })
    }

    @action deleteOutOfStockRecipient(outOfStockRecipientId) {
        return ApiCaller.OutOfStockRecipient.Delete(outOfStockRecipientId).then(() => {
            this.init();
        })
    }

    @action initRead(id) {
        return ApiCaller.OutOfStockRecipient.GetById(id).then((response) => {
            if(response){
                this.email = response.email;
            }
        })
    }
}

export default new outOfStockRecipientStore();